<nav-item label="Room"  [hideChevronRight]="true" [ngClass]="{'active': isActive()}">
    <svg-icon key="room" fontSize="1.5rem"></svg-icon>
</nav-item>